import styled from '@emotion/styled';
import themeGet from '@styled-system/theme-get';
import { Box } from '@qga/roo-ui/components';

const Fields = styled(Box)`
  position: relative;
  padding-bottom: 160px;

  ${themeGet('mediaQueries.0')} {
    padding-bottom: 0;
  }
`;

export default Fields;
